import { Component, Input, OnInit } from '@angular/core';
import { IMyDrpOptions } from 'mydaterangepicker';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ManagerReportsService } from '../../manager-reports.service';
import { IMyOptions } from 'mydatepicker';
import { UsersService } from '../../../users/users.service';
import { constant } from '../../../../app.constants';
import { DriverService } from '../../../../core/services/driver.service';
import * as moment from 'moment';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-payor-date-range-report',
  templateUrl: './payor-date-range-report.component.html',
  styleUrls: ['./payor-date-range-report.component.scss']
})
export class PayorDateRangeReportComponent implements OnInit {
  @Input() title: string;
  @Input() reportPath: string;
  @Input() reportName =  'Report';
  @Input() isDateRange: false;
  @Input() isExcel = false;
  @Input() isPost= false;
  @Input() payorDropdown= false;
  @Input() multiPayorDropdown= false;
  @Input() multiProviderDropdown = false;
  @Input() multiPCPDropdown = false;
  @Input() multiCompanyDropdown = false;
  @Input() multiStatusDropdown = false;
  @Input() multiStatusGroupDropdown = false;
  @Input() multiDriversDropdown = false;
  @Input() callTypeDropdown = false;
  @Input() showOptions = false;
  @Input() LogisticarePayors = false;
  @Input() control = true;
  @Input() selectDateRange: boolean;

  protected isSumary = false;
  protected typesRangeDate = constant.RANGES_DATES;
  protected typeRangeDate = 0;
  protected rangeDate;
  protected selectedPayor: any;
  protected selectedCallTypes: any;
  protected selectedPayors: any;
  protected selectedStatus: any;
  protected selectedDrives: any;
  protected selectedProviders: any;
  protected selectedPcps: any;

  protected selectedCompanies: any;
  protected payors: any[];
  protected providers: any[];
  protected pcps: any[];

  protected companies: any[];
  protected callTypes: any[];
  protected selectDrivers: any[];
  protected statusList = constant.statusList;
  dropdownCallTypeSettings = {};
  dropdownPayorSettings = {};
  dropdownProviderSettings = {};
  dropdownPCPSettings = {};
  dropdownCompaniesSettings = {};
  dropdownStatusSettings = {};
  dropdownDrivesSettings = {};
  protected myDatePickerOptions: IMyDrpOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateRangeField: false,
    markCurrentDay: true
  };
  public myRDPOptions: IMyOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateField: false,
  };
  constructor(
    protected _loading: T2LoadingService,
    protected service: ManagerReportsService,
    protected _serviceUser: UsersService,
    private _driverService: DriverService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {

  }

  ngOnInit() {
    if (this.multiStatusGroupDropdown) { this.statusList = constant.statusGroupList; }

    if (this.payorDropdown || this.multiPayorDropdown )
    {
      this.getPayors();
    }
    if (this.multiProviderDropdown)
    {
      this.getAllProviders();
    }
    if (this.multiPCPDropdown)
    {
      this.getAllPCPs();
    }
    if (this.multiCompanyDropdown) {
      this.getAllCompanies();
    }

    if (this.multiDriversDropdown) {
      this.getDrivers();
    }

    this.dropdownCallTypeSettings = {
      singleSelection: false,
      idField: 'calltypeid',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 250
    };
    this.dropdownPayorSettings = {
      singleSelection: false,
      idField: 'payorid',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 230
    };
    this.dropdownProviderSettings = {
      singleSelection: false,
      idField: 'companyid',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 242
    };
    this.dropdownPCPSettings = {
      singleSelection: false,
      idField: 'primarycarephysicianid',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 242
    };

    this.dropdownCompaniesSettings = {
      singleSelection: false,
      idField: 'brokerid',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 180
    };
    this.dropdownStatusSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 200
    };
    this.dropdownDrivesSettings = {
      singleSelection: false,
      idField: 'userprofileid',
      textField: 'fullname',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight : 200
    };
  }

  /**
   * Get Payors Para reportes
   */
  private getPayors() {
    let ruta = 'list?ShowInactive=false';
    if (this.LogisticarePayors) { ruta = 'Logisticare'; }
    this.service.getPayors(ruta).subscribe(
      data => {
        this.payors = data;
      }
    );
  }
  onChangePayor()
  {
    if (this.callTypeDropdown && this.selectedPayor)
    {
      this.getCallTypes();
    }

  }
  private getCallTypes() {
    this.service.getCallTypesByPayor(this.selectedPayor).subscribe(
      data => {
        this.callTypes = data;
      }
    );
  }
  shareCheckedList(items: any[]) {
    this.callTypes = [];
    this.selectedCallTypes = items;
  }
  onItemSelect(item: any) {
    if (this.multiDriversDropdown) {
      this.getDrivers(item.companyid);
    }
  }
  onSelectAll(items: any) {
  }
  getAllProviders() {
    this._serviceUser.getProvidersForUser('&orderBy=true').subscribe(
      data => {
        this.providers = data;
       });
  }

  getAllPCPs() {
    this._serviceUser.getAllPCPs().subscribe(
      data => {
        this.pcps = data;
      });
  }

  getDrivers(providerId?) {
    this.selectDrivers = [];
    this._driverService.get(providerId, '', false, 4)
      .subscribe((data) => {
          this.selectDrivers = data;
        }
      );
  }

  getAllCompanies() {
    this._serviceUser.getEnableCompanies('&orderBy=true').subscribe(
      data => {
        this.companies = data;
      });
  }

  generateReport() {
    if (this.rangeDate &&
      ((this.selectedPayor && this.payorDropdown) || !this.payorDropdown ) &&
      ((this.selectedCallTypes && this.callTypeDropdown) || !this.callTypeDropdown) ) {
      this._loading.show('Generating Report...This process could take a few minutes');
      const ext = this.isExcel ? 'xlsx' : 'pdf';
      let CalltypeIds: any = null;
      let payorids: any = null;
      let providerids: any = null;
      let companiesIds: any = null;
      let tripStatusIds: any = null;
      let driverIds: any = null;
      if (this.callTypeDropdown)
      {
        CalltypeIds = this.selectedCallTypes.map( row =>  row.calltypeid);
      }
      if (this.multiPayorDropdown)
      {
        payorids = this.selectedPayors.map( row =>  row.payorid);
      }
      if (this.multiProviderDropdown)
      {
        providerids = this.selectedProviders.map( row =>  row.companyid);
      }
      if (this.multiPCPDropdown) {
        providerids = this.selectedPcps.map( row =>  row.primarycarephysicianid);
      }
      if (this.multiStatusDropdown)
      {
        tripStatusIds = this.selectedStatus.map( row =>  row.id);
      }
      if (this.multiDriversDropdown)
      {
        driverIds = this.selectedDrives.map( row =>  row.userprofileid);
      }
      if (this.multiCompanyDropdown) {
        companiesIds = this.selectedCompanies.map(row =>  row.brokerid);
      }
      this.service.generateDateRangeReport(this.reportPath , this.rangeDate, this.selectedPayor, CalltypeIds, payorids, providerids,
        tripStatusIds, driverIds, this.isSumary,  this.isPost, this.isDateRange, this.isExcel)
        .subscribe(
          report => {
            if (report.status !== 200 ) {
              this.sweetAlertHelper.createCustomAlert({
                title: 'Warning',
                type: 'warning',
                text: report.statusText
              });
            }
            this._loading.hiden();
            const blob = report.blob();
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = this.reportName + '.' + ext;
            document.body.appendChild(a);
            a.click();
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success',
              type: 'success',
              text: 'The Report File Should Be Downloading'
            });
          },
          error => {
            this._loading.hiden();
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              type: 'error',
              text: error.message || 'An error has occurred, please try again'
            });
          }
        );
    }else if (!this.control) {
      this._loading.show('Generating Report...This process could take a few minutes');
      this.service.generateDateRangeReport1(this.reportPath, this.isPost, this.isExcel).subscribe(
        report => {
          if (report.status !== 200 ) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Warning',
              type: 'warning',
              text: report.statusText
            });
          }
          this._loading.hiden();
          const blob = report.blob();
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = this.reportName + '.' + 'xlsx';
          document.body.appendChild(a);
          a.click();
          this.sweetAlertHelper.createCustomAlert({
            title: 'Success',
            type: 'success',
            text: 'The Report File Should Be Downloading'
          });
        },
        error => {
          this._loading.hiden();
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            type: 'error',
            text: error.message || 'An error has occurred, please try again'
          });
        }
      );
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        type: 'error',
        text: 'All parameter should be selected'
      });

    }
  }

  /**@name selectRangeCustom
   * @description Pasa a custom el select
   */
  selectRangeCustom() {
    if (this.typeRangeDate !== 0) {
      this.typeRangeDate = 0;
    }
  }
  /**@name setDatesOrType
   * @description ejecuta segun type
   */
  setDatesOrType() {
    switch (this.typeRangeDate) {
      case 1: this.yesterdayAndBefore(1);
        break;
      case 2: this.yesterdayAndBefore(2);
        break;
      case 3: this.todayAndAdd(0);
        break;
      case 4: this.todayAndAdd(1);
        break;
      case 5: this.todayAndAdd(2);
        break;
      case 6: this.lastFullWeek();
        break;
      case 7: this.lastFullMonth();
        break;
      case 8: this.LastSevenDays();
        break;
      case 9: this.weekToDateFromSunday();
        break;
      case 10: this.monthToDate();
        break;
      case 11: this.yeartoDate();
        break;
      case 12: this.selectQuarters(1);
        break;
      case 13: this.selectQuarters(2);
        break;
      case 14: this.selectQuarters(3);
        break;
      case 15: this.selectQuarters(4);
        break;
      case 16: this.selectHalfYear(1);
        break;
      case 17: this.selectHalfYear(2);
        break;
      case 18:
        break;
    }
  }

  /**@name setDate
   * @description retorna date a setear
   */
  setDate(date: Date) {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  /**@name setDateRange
   * @description setea valor rango de fecha
   */
  setDateRange(begin: Date, end: Date): void {
    this.rangeDate = {
       beginDate: this.setDate(begin),
       endDate: this.setDate(end)
    };
  }


  yesterdayAndBefore(numDay: number): void {
    const day: Date = moment().subtract(numDay, 'day').toDate();
    this.setDateRange(day, day);
  }

  todayAndAdd(numDay): void {
    const day: Date = moment().add(numDay, 'day' ).toDate();
    this.setDateRange(day, day);
  }


  lastFullWeek(): void {
    const beginWeek: Date = moment().subtract(1, 'week' ).startOf('week').toDate();
    const endWeek: Date = moment().subtract(1, 'week' ).endOf('week').toDate();
    this.setDateRange(beginWeek, endWeek);
  }

  lastFullMonth(): void {
    const beginMonth: Date = moment().subtract(1, 'month' ).startOf('month').toDate();
    const endMonth: Date = moment().subtract(1, 'month' ).endOf('month').toDate();
    this.setDateRange(beginMonth, endMonth);
  }

  LastSevenDays(): void {
    const beginDay: Date = moment().subtract(7, 'day').toDate();
    const end: Date = moment().toDate();
    this.setDateRange(beginDay, end);
  }

  weekToDateFromSunday(): void {
    const begin: Date = moment().startOf('week').toDate();
    const end: Date = moment().endOf('week').toDate();
    this.setDateRange(begin, end);
  }

  monthToDate(): void {
    const beginMonth: Date = moment().startOf('month').toDate();
    const end: Date = moment().toDate();
    this.setDateRange(beginMonth, end);
  }

  yeartoDate(): void {
    const beginYear: Date = moment().startOf('year').toDate();
    const end: Date = moment().toDate();
    this.setDateRange(beginYear, end);
  }

  selectQuarters(quarter: number) {
    const addMonth: number = (quarter - 1) * 3;
    const begin: Date = moment(moment().startOf('year')).add(addMonth, 'month').startOf('month').toDate();
    const end: Date = moment(begin).add(2, 'month').endOf('month').toDate();
    this.setDateRange(begin, end);
  }


  selectHalfYear(half: number) {
    const addMonth: number = (half - 1) * 6;
    const begin: Date = moment(moment().startOf('year')).add(addMonth, 'month').startOf('month').toDate();
    const end: Date = moment(begin).add(5, 'month').endOf('month').toDate();
    this.setDateRange(begin, end);
  }


}




// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/components/payor-date-range-report/payor-date-range-report.component.ts